module.exports = __webpack_public_path__ + "static/Insurance-details-880b1fe4214cd87ccc4901e2b0420e24.png";